(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4557"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4557"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1tsFs", function(module, exports) {

$parcel$export(module.exports, "POLICY_COOKIE_NAME", function () { return $112ebca8b6779b7a$export$885d3f877b02ad5e; });
$parcel$export(module.exports, "POLICY_COOKIE_DURATION_DAYS", function () { return $112ebca8b6779b7a$export$1700a12fea6abfe; });
$parcel$export(module.exports, "PREFERENCES_COOKIE_NAME", function () { return $112ebca8b6779b7a$export$c3fe1e1cf9e20a1a; });
$parcel$export(module.exports, "PREFERENCES_COOKIE_DURATION_DAYS", function () { return $112ebca8b6779b7a$export$9cb3d4d372ca1c3b; });
const $112ebca8b6779b7a$export$885d3f877b02ad5e = "cookies_policy";
const $112ebca8b6779b7a$export$1700a12fea6abfe = 365;
const $112ebca8b6779b7a$export$c3fe1e1cf9e20a1a = "cookie_preferences_set";
const $112ebca8b6779b7a$export$9cb3d4d372ca1c3b = 365;

});

parcelRegister("fNeCG", function(module, exports) {

$parcel$export(module.exports, "getCookie", function () { return $b7f6c668062e443f$export$4be65e66cfa2648a; });
$parcel$export(module.exports, "getDefaultPolicy", function () { return $b7f6c668062e443f$export$3389be4b12db17b4; });
$parcel$export(module.exports, "setPoliciesCookie", function () { return $b7f6c668062e443f$export$5d0c102c5d7f343d; });
$parcel$export(module.exports, "setPreferencesCookie", function () { return $b7f6c668062e443f$export$388b1b948d9d3542; });

var $1tsFs = parcelRequire("1tsFs");
const $b7f6c668062e443f$export$4be65e66cfa2648a = (name)=>{
    const nameEQ = name + "=";
    const cookies = document.cookie.split(";");
    for(let i = 0, len = cookies.length; i < len; i++){
        let cookie = cookies[i];
        while(cookie.charAt(0) === " ")cookie = cookie.substring(1, cookie.length);
        if (cookie.indexOf(nameEQ) === 0) return decodeURIComponent(cookie.substring(nameEQ.length));
    }
    return null;
};
const $b7f6c668062e443f$export$110700823644f4a6 = (name, value, options)=>{
    if (typeof options === "undefined") options = {};
    let cookieString = name + "=" + value + "; path=/";
    if (options.days) {
        let date = new Date();
        date.setTime(date.getTime() + options.days * 86400000);
        cookieString = cookieString + "; expires=" + date.toGMTString();
    }
    if (options.sameSite) cookieString = cookieString + `; SameSite=${options.sameSite}`;
    if (document.location.protocol === "https:") cookieString = cookieString + "; Secure";
    document.cookie = cookieString;
};
const $b7f6c668062e443f$export$3389be4b12db17b4 = ()=>({
        essential: true,
        settings: false,
        usage: false,
        campaigns: false
    });
const $b7f6c668062e443f$export$5d0c102c5d7f343d = (settings, usage, campaigns)=>{
    const policy = $b7f6c668062e443f$export$3389be4b12db17b4();
    policy.settings = settings || false;
    policy.usage = usage || false;
    policy.campaigns = campaigns || false;
    const json = JSON.stringify(policy);
    $b7f6c668062e443f$export$110700823644f4a6((0, $1tsFs.POLICY_COOKIE_NAME), json, {
        days: (0, $1tsFs.POLICY_COOKIE_DURATION_DAYS),
        sameSite: "Lax"
    });
    return policy;
};
const $b7f6c668062e443f$export$388b1b948d9d3542 = ()=>{
    $b7f6c668062e443f$export$110700823644f4a6((0, $1tsFs.PREFERENCES_COOKIE_NAME), "true", {
        days: (0, $1tsFs.PREFERENCES_COOKIE_DURATION_DAYS),
        sameSite: "Lax"
    });
};

});


var $1tsFs = parcelRequire("1tsFs");

var $fNeCG = parcelRequire("fNeCG");
class $611764570079e889$var$CookiePreferences {
    constructor(formSelector, confirmationSelector, radioButtons){
        this.formSelector = formSelector;
        this.confirmationSelector = confirmationSelector;
        this.radioButtons = radioButtons;
        this.form = document.querySelector(this.formSelector);
    }
    boolToValue(b) {
        return b ? "on" : "off";
    }
    valueToBool(value) {
        return value === "on";
    }
    getPolicyOrDefault() {
        const cookie = (0, $fNeCG.getCookie)((0, $1tsFs.POLICY_COOKIE_NAME));
        const policy = (0, $fNeCG.getDefaultPolicy)();
        if (!cookie) return policy;
        try {
            const parsed = JSON.parse(cookie);
            policy.campaigns = parsed.campaigns || false;
            policy.usage = parsed.usage || false;
            policy.settings = parsed.settings || false;
        } catch (e) {
            return policy;
        }
        return policy;
    }
    initFormValues() {
        const policy = this.getPolicyOrDefault();
        Object.entries(this.radioButtons).forEach(([cookieKey, inputName])=>{
            this.form[inputName].value = this.boolToValue(policy[cookieKey]);
        });
    }
    setPoliciesCookie() {
        const policy = {
            settings: false,
            usage: false,
            campaigns: false
        };
        Object.entries(this.radioButtons).forEach(([cookieKey, inputName])=>{
            policy[cookieKey] = this.valueToBool(this.form[inputName].value);
        });
        (0, $fNeCG.setPoliciesCookie)(policy.settings, policy.usage, policy.campaigns);
    }
    displayConfirmation() {
        const confirmationEl = document.querySelector(this.confirmationSelector);
        confirmationEl.style.display = "block";
    }
    bindForm() {
        this.form.addEventListener("submit", (evt)=>{
            evt.preventDefault();
            this.setPoliciesCookie();
            (0, $fNeCG.setPreferencesCookie)();
            this.displayConfirmation();
            window.scrollTo(0, 0);
            return false;
        });
    }
}
const $611764570079e889$var$initCookiePreferences = (formSelector, confirmationSelector, radioButtons)=>{
    const cookiePreferences = new $611764570079e889$var$CookiePreferences(formSelector, confirmationSelector, radioButtons);
    cookiePreferences.initFormValues();
    cookiePreferences.bindForm();
};
var $611764570079e889$export$2e2bcd8739ae039 = $611764570079e889$var$initCookiePreferences;


(0, $611764570079e889$export$2e2bcd8739ae039)("#cookie-preferences-form", ".cookie-settings__confirmation", {
    usage: "cookies-usage"
});

})();
//# sourceMappingURL=cookie-policy-form.js.map
